import { render, staticRenderFns } from "./HandbookChapter.vue?vue&type=template&id=9700e610&lang=pug&"
import script from "./HandbookChapter.vue?vue&type=script&lang=ts&"
export * from "./HandbookChapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports